import type { ComponentProps } from 'react';
import { cn } from '@/ui-kit/utils';

export const HiddenRadioInput = ({ className, ...props }: Omit<ComponentProps<'input'>, 'type'>) => (
  <input type="radio" className={cn('peer sr-only', className)} {...props} />
);
